import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import {initSentry, Sentry} from "./sentry/sentry";
import {ApplicationRef, NgModuleRef, provideZoneChangeDetection} from "@angular/core";
import {enableDebugTools} from "@angular/platform-browser";
import {environment} from "./environment/environment.dev";

initSentry()
cleanupStaleServiceWorker()

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .then(moduleRef => {
    if (!environment.production) {
      enableDebuggingTools(moduleRef);
    }
  })
  .catch(err => {
    // Si le bootstrap Angular plante, l'application ne démarre pas du tout : c'est le pire
    // cas possible et il doit absolument remonter à Sentry, pas seulement à la console.
    console.error(err);
    Sentry.captureException(err);
  });

/**
 * Exécuter cette commande dans la console pour afficher le nombre de `change detection cycles`
 * et le nombre de ms per check
 *
 *     ng.profiler.timeChangeDetection()
 *
 * Et cette commande pour générer un rapport dans l'onglet Performance du devTools
 *
 *     ng.profiler.timeChangeDetection({record: true})
 *
 * @param moduleRef
 */
function enableDebuggingTools(moduleRef: NgModuleRef<AppModule>) {
  // TODO voir si ça peut être exécuté en tests unitaires / auto dans le CI.
  const applicationRef = moduleRef.injector.get(ApplicationRef)
  const componentRef = applicationRef.components[0]
  enableDebugTools(componentRef)
}

/**
 * Le PWA Service Worker a été activé en production jusqu'en juillet 2023, puis désactivé
 * (ServiceWorkerModule.register(..., { enabled: false })). Ce `enabled: false` empêche
 * seulement un nouvel enregistrement, il ne désenregistre pas un Service Worker déjà actif
 * dans le navigateur d'un utilisateur : ces navigateurs restent bloqués indéfiniment sur le
 * build mis en cache à l'époque, sans jamais recevoir les nouveaux déploiements.
 */
function cleanupStaleServiceWorker(): void {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations()
      .then(registrations => registrations.forEach(registration => registration.unregister()))
      .catch(err => console.error('Échec du désenregistrement du Service Worker existant', err));
  }

  if ('caches' in window) {
    caches.keys()
      .then(keys => keys.filter(key => key.startsWith('ngsw:')).forEach(key => caches.delete(key)))
      .catch(err => console.error('Échec du nettoyage des caches du Service Worker', err));
  }
}
